module.exports = __webpack_public_path__ + "img/injury_recovery_icon.c7d84bfb.svg";